// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.crateMovements > span[data-v-0828b05e] {\n  margin: 2px;\n}\n.crateMovements > span[data-v-0828b05e]:hover {\n  background-color: #ef476f;\n  cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
